/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamReferenceShowQueryResponse,
  GetApiV1ExamReferenceShow401,
  GetApiV1ExamReferenceShow500,
} from "../../types/examEvaluationController/GetApiV1ExamExamReferenceShow.ts";

function getGetApiV1ExamExamReferenceShowUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/exam/exam-reference-show` as const,
  };
  return res;
}

/**
 * @description Retorna todas as opções de exibição de gabarito disponíveis para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Listar opções de exibição de gabarito para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-reference-show}
 */
export async function getApiV1ExamExamReferenceShow(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamReferenceShowQueryResponse,
    ResponseErrorConfig<
      GetApiV1ExamReferenceShow401 | GetApiV1ExamReferenceShow500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamExamReferenceShowUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
